<script>
import {updateMontant} from '../../../mixins/updateMontant.js';

export default {
  name: 'ligneAFacturer',
  props:{
    phaseId: String,
    phaseName: String,
    visible: Boolean,
    honos: Number,
    factured: Number,
  },
  mixins:[
    updateMontant,
  ],
  data(){
    return {
      pourcentage: 100 - Math.round(this.factured / this.honos * 1000)/10,
      montantFacture : this.honos - this.factured,
      tva: 20,
    }
  },
  computed:{
      isVisible () {
        return 'background-color: ' + this.hovering ? this.color: 'red';
      },
      avancement(){
        let result = Math.round((parseFloat(this.montantFacture) + this.factured)/this.honos*1000)/10
        if (isNaN(result)){
          result = Math.round(this.factured/this.honos*1000)/10
        }
        return result
      },
      ttc(){
        let result = Math.round(((parseFloat(this.montantFacture) * this.tva / 100) + parseFloat(this.montantFacture))*100)/100
        return result
      },
      styleAvancement(){
        if (this.avancement > 100){
          return 'color: red;'
        } else {
          return ''
        }        
      },
  },
  mounted(){
    
  },
  watch: {
    // Quand on passe à visible = true, on renvoie au parent le contenu
    visible: function (newVal) { //(newVal, oldVal)
      if (newVal){
        this.updateParent()
      }
    }
  },
  methods:{
    pourcentageToMontant(pourcentage){
      this.montantFacture = this.honos * pourcentage / 100
      this.updateParent()
    },
    montantToPourcentage(montant){
      this.pourcentage = Math.round(montant / this.honos * 1000)/10
      this.updateParent()
    },
    updateParent(){
      this.$emit('update', {phaseId: this.phaseId, ht:this.montantFacture, ttc:this.ttc})
    },
  }
}
</script>


<template>
  <div v-if="visible" class="ligneAFacturer">
    <div class="first"><span>Facturé à <span :style="styleAvancement">{{avancement}}%</span>après facture :</span><input type="text" style="display:none" :value="phaseId"/></div>
    <!-- Le max 100 est logique, mais avec BLP ils facturent parfois plus que 100%... à voir pourquoi... -->
    <!-- <div><input type="number" class="pourcentages"  step="0.1"  v-model="pourcentage" max="100" @keyup="pourcentageToMontant($event.target.value)" /><span class="unit">%</span></div> -->
    <div><input type="number" class="pourcentages"  step="0.1"  v-model="pourcentage" max="100" @keyup="pourcentageToMontant($event.target.value)" /><span class="unit">%</span></div>
    <div><input type="number" class="montants"      step="0.01" v-model="montantFacture" @keyup="montantToPourcentage($event.target.value)" /><span class="unit">€<sup>ht</sup></span></div>
    <div><input type="number" class="pourcentages"  step="0.1"  v-model="tva" min="0" @keyup="updateParent()" /><span class="unit">%</span></div>
    <span> {{ttc}}€<sup>ttc</sup></span>
  </div>
  <div v-else class="ligneAFacturer">
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/main.scss';

.ligneAFacturer{
    display: grid; //Grid identique au footer du parent "factureItem", à l'élément "ligneFormulaire", et à l'enfant "factureLine"
    grid-template-columns: 3fr 1fr 2fr 2fr 2fr;

    @include myFont;
    font-size: 13px;

    & *{
      justify-self: right;
    }
}

input{
  border-width: 0 0 1px 0;
  border-color: $main;
  background-color: $black-lighter;
  @include myFont;
  font-size: 13px;
  margin: 0 -2px 0 0;

  // Supprimer les flèches du type Number
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button{
    -webkit-appearance: none;
    margin: 0;
  }
}

.first{
  display: flex;
  justify-content: space-between;
  justify-self: left;
  & span{
    margin: 0 5px 0 0;
  }
}

.pourcentages{
  width: 35px;
  text-align: right;
}

.montants{
  width: 80px;
  text-align: right;
}

.unit{
  margin: 0 0 0 3px;
}

.hidden{
  visibility: hidden;
}

</style>
